// @flow

import * as React from 'react';
import {useAccount} from 'docs/data';
import {normalizeHostname} from 'docs/util';
import './VideoLink.scss';

type VideoLinkProps = {|
  href: string,
  title?: string,
  id?: string,
  children?: React.Node,
|};

export const VideoLink = (props: VideoLinkProps) => {
  const {account} = useAccount();
  return (
    <a
      className="VideoLink"
      href={normalizeHostname(props.href, account.hosts)}
      {...props}
    >
      {props.children}
    </a>
  );
};
